import { useMutation } from '@apollo/client/react';

import { DELETE_EVENT, GET_FILTERED_EVENTS } from '../../graphql/queries';
import useBuildGraphQLVariables from '../useBuildGraphQLVariables/useBuildGraphQLVariables';

function useDeleteEvent() {
  const filters = useBuildGraphQLVariables(); // Build filters using the same method as your event fetching

  const [deleteEventMutation, { loading, error }] = useMutation(DELETE_EVENT, {
    onError: (err) => {
      console.error('Error deleting event:', err);
    },
    refetchQueries: [
      {
        query: GET_FILTERED_EVENTS,
        variables: { filters: filters }, // Use the built filters for refetching
      },
    ],
    update: (cache, { data }) => {
      if (data) {
        const existingEvents = cache.readQuery({
          query: GET_FILTERED_EVENTS,
          variables: { filters: filters },
        });
        const newEvents = existingEvents?.gec_events.filter(
          (event: { id: number }) => event.id !== data.delete_gec_events_by_pk?.id,
        );
        cache.writeQuery({
          query: GET_FILTERED_EVENTS,
          variables: { filters: filters },
          data: { gec_events: newEvents ?? [] },
        });
      }
    },
  });

  const deleteEvent = (eventId: number) => {
    void deleteEventMutation({
      variables: {
        id: eventId,
      },
    });
  };

  return { deleteEvent, loading, error };
}

export default useDeleteEvent;
